const BASE_URL = "https://fullstack-web-development-registration-w0os.onrender.com/api/";

export default BASE_URL;
